var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"cp-request"}},[_c('b-modal',{ref:"cpReqMod",attrs:{"id":"cp-request-popup","hide-header":"","hide-footer":"","centered":""},on:{"hide":_vm.onHide}},[_c('CpRequest',{attrs:{"hide-modal":_vm.hide}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }